import { render, staticRenderFns } from "./SourceSelection.vue?vue&type=template&id=7ff3ea0b&scoped=true&"
import script from "./SourceSelection.vue?vue&type=script&lang=js&"
export * from "./SourceSelection.vue?vue&type=script&lang=js&"
import style0 from "./SourceSelection.vue?vue&type=style&index=0&id=7ff3ea0b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ff3ea0b",
  null
  
)

export default component.exports